<!-- 重新分配 -->
<template>
  <div class="import-tool">
    <Modal
      v-model="visible"
      title="删除客户"
      :mask-closable="false"
      width="420"
      :footer-hide="true"
      class="my-modal top"
    >
      <Form v-if="visible" ref="form" :model="from" class="page-form less" :label-width="70">
        <FormItem label="客户姓名" class="full">
          <Input disabled v-model="from.name"/>
        </FormItem>
        
        <FormItem prop="agentDelReason" label="删除原因" class="full">
          <Input maxlength="30" :autosize="{minRows: 2,maxRows: 2}" show-word-limit type="textarea" v-model="from.agentDelReason" placeholder="请输入删除原因"/>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible=false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props:['getInsureList'],
  components: {},
  data() {
    return {
      visible: false,
      from:{}
    };
  },
  methods: {
    open(data) {
      this.from = data;
      this.from.agentDelReason = '';
      this.visible = true;
    },

    ok() {
      this.$refs.form.validate((valid, obj) => {
        if (!valid) {
          return;
        }
        this.submit(obj);
      });
    },

    save(){
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        let data = {
          id:this.from.id,
          agentDelReason:this.from.agentDelReason
        }
        this.$http({
          url: "/buz/customerBase/agentDelCustomer",
          type: "POST",
          data
        }).then(res=>{
          this.visible = false;
          this.$notice.success('删除成功');
          this.getInsureList();
        })        
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {

  .ivu-modal-body {
    padding-bottom: 40px;
  }
  .ivu-modal-header-inner {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
  }
  .ivu-modal-close {
    top: 4px;
    .ivu-icon-ios-close {
      font-size: 30px;
      color: #a8adb7;
    }
  }
  .ivu-modal-header {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }
  .confirm {
    margin: 0 auto;
    width: 100px;
    height: 30px;
    background-color: #236dff;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #fff;
  }
}
/deep/ .ivu-form-item-label {
  font-size: 12px;
}
/deep/ .treeNode {
  font-size: 12px !important;
}
/deep/ .ivu-select-placeholder {
  font-size: 12px !important;
}
/deep/ textarea::-webkit-input-placeholder {
  font-size: 12px !important;
}

</style>
